import { defineFetchForNamespace } from '../../redux/fetch';

import { fetchCart } from '../service';
import { Cart } from '@pegasus/cart/types/cart';
import { combineReducers } from 'redux';

export const NAME = 'fetch';
export const NAMESPACE = 'cart';

const {
    reducer,
    getIsInitial,
    getIsLoading,
    getData,
    resetData,
    fetchData,
} = defineFetchForNamespace<Cart, void, typeof NAMESPACE, typeof NAME>(NAMESPACE, NAME, () =>
    fetchCart(),
);

const getCartReducer = () => ({
    [NAMESPACE]: combineReducers({
        [NAME]: reducer,
    }),
});

export {
    getCartReducer,
    getIsInitial,
    getIsLoading,
    getData as getCart,
    fetchData as fetchCart,
    resetData as resetCart,
};
